export default "__VITE_ASSET__oNLX_XNu__"